<template>
  <div>
    <!-- search input -->
    <div class="molecule-datatable--header-search-container">
      <slot name="leftOfSearch"></slot>
      <div class="molecule-datatable--header-search-container-input">
        <atom-input
          v-if="enabledSearch"
          v-model="inputSearch"
          :placeholder="placeholderSearch"
          :isDisable="inputDisable"
        ></atom-input>
      </div>
    </div>

    <!-- table -->
    <vue-good-table
      :columns="fields"
      :rows="items"
      :max-height="maxHeight"
      styleClass="vgt-table"
      :search-options="{
        enabled: enabledSearch,
        externalQuery: inputSearch,
      }"
      :select-options="{
        enabled: enabledSelect,
        selectOnCheckboxOnly: true,
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true,
        selectAllByGroup: true,
      }"
      :pagination-options="{
        enabled: isShowPagination,
        perPage: perPage,
      }"
      @on-row-dblclick="onRowDoubleClick"
      @on-selected-rows-change="selectionChanged"
      @on-row-click="onRowClick"
      @on-select-all="onSelectAll"
      @on-page-change="onPageChange"
      @on-row-mouseenter="onRowMouseover"
      @on-row-mouseleave="onRowMouseleave"
    >
      <template #table-row="props">
        <div v-if="isCustomized">
          <div v-for="(_, slotName) of $scopedSlots" :key="slotName">
            <div v-if="props.column.field === slotName">
              <slot :name="slotName" v-bind="props"></slot>
            </div>
          </div>
        </div>
      </template>

      <!-- pagination -->
      <template #pagination-bottom="props">
        <div class="molecule-datatable--pagination">
          <label class="text-secondary molecule-datatable--pagination-text"
            >Showing {{ props.total }} entries</label
          >
          <atom-pagination
            :totalRows="props.total"
            :perPage="perPage"
            v-model="currentPage"
            @input="
              (pageSelected) => props.pageChanged({ currentPage: pageSelected })
            "
          ></atom-pagination>
        </div>
      </template>

      <template #emptystate>
        <slot name="emptyData"></slot>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import AtomInput from "@/components/atoms/AtomInput.vue"
import { VueGoodTable } from "vue-good-table"
import AtomPagination from "@/components/atoms/AtomPagination.vue"
import AtomCheckbox from "@/components/atoms/AtomCheckbox.vue"

export default {
  name: "MoleculeDataTable",
  components: {
    AtomInput,
    VueGoodTable,
    AtomPagination,
    AtomCheckbox,
  },
  props: {
    placeholderSearch: {
      type: String,
      required: false,
      default: "Filter table"
    },
    fields: {
      type: Array,
      required: true,
      //value = [{field: String, label: String, sortable: Boolean}, ...]
    },
    items: {
      type: Array,
      required: true,
      //value = [{field: value, ...}, ...]
    },
    // search input
    enabledSearch: {
      type: Boolean,
      required: false,
      default: true,
    },
    isCustomized: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxHeight: {
      type: String,
      required: false,
      default: "",
    },
    // pagination
    isShowPagination: {
      type: Boolean,
      required: false,
      default: true,
    },
    enabledSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: String,
      required: true,
    },
  },
  emits: [
    "onRowClick",
    "onRowDoubleClick",
    "selectionChanged",
    "onSelectAll",
    "onPageChange",
  ],
  data() {
    return {
      // slotName: this.fields.field,
      inputSearch: "",
      currentPage: 1,
      perPage: 10,
    }
  },
  watch: {
    perPage() {
      if (!isShowPagination) this.perPage = this.items.length
    },
  },
  computed: {
    inputDisable() {
      if (this.items.length === 0) return true
      else return false
    },
  },
  methods: {
    onRowClick(params) {
      this.$emit("onRowClick", params)
    },
    onRowDoubleClick(params) {
      this.$emit("onRowDoubleClick", params)
    },
    selectionChanged(params) {
      this.$emit("selectionChanged", params.selectedRows)
    },
    onSelectAll(params) {
      this.$emit("onSelectAll", params)
    },
    onPageChange(params) {
      this.$emit("onPageChange", params)
    },
    onRowMouseover(params) {
      this.$emit("onHoverRow", params)
    },
    onRowMouseleave(row, pageIndex) {
      this.$emit("onHoverLeave", row, pageIndex)
    },
  },
}
</script>

<style lang="scss" scoped>
.molecule-datatable--header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.molecule-datatable--header-container {
  display: flex;
  align-items: center;
  width: 144px;
  justify-content: space-between;
}

.molecule-datatable--header-text {
  margin-bottom: 18px;
}

.molecule-datatable--header-search-container {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
}

.molecule-datatable--header-search-container-input {
  width: 100%;
}

.molecule-datatable--pagination {
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.molecule-datatable--pagination-text {
  font-size: 14px;
  margin-bottom: 1rem;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .molecule-datatable--header-search-container-input {
    width: 234px;
  }
}
// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .molecule-datatable--header-search-container {
    flex-direction: row;
  }
  .molecule-datatable--header-search-container-input {
    width: 234px;
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
